/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b5b8d71cc98ac1fbefcab588d34b34b7f627460b";
